<template>
  <v-tabs vertical>
    <!-- Weekly website usage -->
    <v-tab>Weekly Usage</v-tab>
    <v-tab-item> </v-tab-item>
  </v-tabs>
</template>
<script>
import ChartBar from "@/components/ChartBar"
export default {
  name: "PulseStandalone",
  components: {
    // eslint-disable-next-line vue/no-unused-components
    ChartBar
  },
  data() {
    return {
      week: {
        startDate: this.$date()
          .subtract(7, "days")
          .startOf("week")
          .toISOString(),
        endDate: this.$date().subtract(7, "days").endOf("week").toISOString()
      }
    }
  },
  methods: {
    getDigitalWellbeing() {
      this.axios.post("/api/v1/insights/pulse/week", {
        startDate: this.week.startDate,
        endDate: this.week.endDate
      })
    }
  },
  mounted() {
    this.getDigitalWellbeing()
  }
}
</script>

<style scoped></style>
